import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from '@ui/shared/feature-config';
import { AppComponent } from './app/app.component';
import { SchoolMapDataStateService } from './app/services/school-map-data-state.service';

bootstrapApplication(AppComponent, createAppConfig({
    mapDataStateService: SchoolMapDataStateService,
})).catch((err: unknown) => console.error(err));
